import { Injectable } from '@angular/core';
import { RequestMethod, SgWebHttpClient } from '@ds/ng-wt-helpers/http';
import { APP_CONFIG_URL, APP_CONTENT_URL, APP_CONTENTS_LIST_URL, AWS_CONTENT_TYPE, AWS_CREDENTIALS_X_AMZ_TARGET, AWS_CREDENTIALS_X_AMZ_USER_AGENT, COGNITO_PREFIX_DOMAIN, COGNOTI_SUFFIX_DOMAIN, CONTENT_DATA_TYPES, CONTENT_ROUTES_PATHS, IDENTITY_ID_X_AMZ_TARGET, IDENTITY_ID_X_AMZ_USER_AGENT } from '../constants/contents.constants';
import { LoginDetailsService } from 'src/app/core/login/services/login-details.service';
import { ThemeDataService } from 'src/app/core/login/services/theme-data.service';
import { NgToastTranslocoService } from 'src/app/common/services/ng-toast-transloco/ng-toast-transloco.service';
import { menuData } from 'src/app/const/menu.const';
import { CryptoService } from './crypto.service';
import { ConfigurationsService } from 'src/app/modules/configurations/services/configurations.service';
import { AwsCredentialsData } from 'src/app/core/login/interfaces/login-details.interface';
import { AwsClient } from 'aws4fetch';
import { LoaderService } from 'src/app/common/services/loader/loader.service';
import { PlayerInformationService } from 'src/app/modules/player-information/services/player-information.service';
import { PlayerService } from './player.service';

@Injectable({
  providedIn: 'root'
})

export class ContentsService {

  appConfigs = window['config'];

  private configLoaded = false;
  private configLoadingPromise: Promise<void> | null = null;

  constructor(private http: SgWebHttpClient,
    private loginDetailsService: LoginDetailsService,
    private themeDataService: ThemeDataService,
    private toast: NgToastTranslocoService,
    private cryptoService: CryptoService,
    private configurationService: ConfigurationsService,
    private loaderService: LoaderService,
    private playerInformationService: PlayerInformationService,
    private playerService: PlayerService
  ) { }

  async getSystemsConfigurationsAsync(): Promise<any> {
    try {
      const awsConfigs = await this.loginDetailsService.getAwsSignatureAuthorizationConfig();
      if (!awsConfigs) {
        return null;
      }
      const awsClient = new AwsClient({ accessKeyId: awsConfigs.AccessKey, secretAccessKey: awsConfigs.SecretKey, region: awsConfigs.contentRegion, sessionToken: awsConfigs.sessionToken });
      let contentServiceUrl = APP_CONFIG_URL(this.appConfigs.contentServiceBaseUrl, this.appConfigs.appId, this.appConfigs.tenantCode);
      const configResponse = await awsClient.fetch(contentServiceUrl, { method: 'GET' });
      const configData = configResponse.json();
      return configData;
    } catch (error) {
      this.toast.toastError('MODULES.COMMON.MESSAGES.ERROR_WHILE_RETRIEVING_CONFIGURATIONS_DATA');
      return null;
    }
  }


  async getAppContents(entryId: string) {
    try {
      const awsConfigs = await this.loginDetailsService.getAwsSignatureAuthorizationConfig();
      if (!awsConfigs) {
        return null;
      }
      const awsClient = new AwsClient({ accessKeyId: awsConfigs.AccessKey, secretAccessKey: awsConfigs.SecretKey, region: awsConfigs.contentRegion, sessionToken: awsConfigs.sessionToken });
      let contentUrl = APP_CONTENT_URL(this.appConfigs.contentServiceBaseUrl, this.appConfigs.appId, entryId)
      const contentResponse = await awsClient.fetch(contentUrl, { method: 'GET' });
      const contentData = contentResponse.json();
      return contentData;
    } catch (error) {
      // this.toast.toastError('MODULES.COMMON.MESSAGES.ERROR_WHILE_RETRIEVING_DATA');
      return null;
    }
  }

  async getAppContentsList(categoryKey: string) {
    try {
      const awsConfigs = await this.loginDetailsService.getAwsSignatureAuthorizationConfig();
      if (!awsConfigs) {
        return null;
      }

      const awsClient = new AwsClient({ accessKeyId: awsConfigs.AccessKey, secretAccessKey: awsConfigs.SecretKey, region: awsConfigs.contentRegion, sessionToken: awsConfigs.sessionToken });
      let contentListUrl = APP_CONTENTS_LIST_URL(this.appConfigs.contentServiceBaseUrl, this.appConfigs.appId, categoryKey);
      const contentResponse = await awsClient.fetch(contentListUrl, { method: 'GET' });
      const contentData = contentResponse.json();
      return contentData;
    } catch (error) {
      // this.toast.toastError('MODULES.COMMON.MESSAGES.ERROR_WHILE_RETRIEVING_DATA');
      return null;
    }
  }

  async getIdentityId(region: string, identityPoolId: string) {
    try {
      let cognitoURL = COGNITO_PREFIX_DOMAIN + '.' + region + '.' + COGNOTI_SUFFIX_DOMAIN + '/';
      let postBody = { 'IdentityPoolId': identityPoolId };

      return await this.http.restAPIAsync<any>(
        RequestMethod.POST,
        cognitoURL,
        {
          body: postBody,
          headers: {
            'Content-Type': AWS_CONTENT_TYPE,
            'X-Amz-Target': IDENTITY_ID_X_AMZ_TARGET,
            'X-Amz-User-Agent': IDENTITY_ID_X_AMZ_USER_AGENT
          }
        }
      );
    } catch (error) {
      this.toast.toastError('MODULES.COMMON.MESSAGES.ERROR_WHILE_RETRIEVING_IDENTITY_ID');
      return null;
    }
  }

  async getAWSCredentials(region: string, identityId: string) {
    try {
      let cognitoURL = COGNITO_PREFIX_DOMAIN + '.' + region + '.' + COGNOTI_SUFFIX_DOMAIN + '/';
      let postBody = { 'IdentityId': identityId };

      return this.http.restAPIAsync<any>(
        RequestMethod.POST,
        cognitoURL,
        {
          body: postBody,
          headers: {
            'Content-Type': AWS_CONTENT_TYPE,
            'X-Amz-Target': AWS_CREDENTIALS_X_AMZ_TARGET,
            'X-Amz-User-Agent': AWS_CREDENTIALS_X_AMZ_USER_AGENT
          }
        }
      );
    } catch (error) {
      this.toast.toastError('MODULES.COMMON.MESSAGES.ERROR_WHILE_RETRIEVING_AWS_CREDENTIALS');
      return null;
    }
  }

  async saveConfigurations(response: any) {
    let systemConfigurations = response.MVConfiguration?.SystemEndpointConfigurations || '';
    let playerManagementSystemAttributes = response.MVConfiguration?.PlayerManagementSystemAttributes || {};
    let allCountriesAndStatesDataUrl = response.MVConfiguration?.Metadata?.AllCountriesAndStatesDataUrl || '';
    let accountIdMap = response.MVConfiguration?.Metadata?.AccountIdMap || {};
    let myAccountConfiguration = response.MVConfiguration?.MyAccountConfiguration || {};
    let cmsOfferTypes = response.MVConfiguration?.CMSOfferTypes || [];
    let OfferConfigration = response.MVConfiguration?.OfferConfigration || {};
    let mvStyle = response?.MVStyle || {};
    let appThemingStyle = response.MVConfiguration?.Metadata?.AppBrightness || '';
    let tierLevelBenefits = response?.MVConfiguration?.TierLevelBenefits || {};
    let mvTabs = response?.MVTabs || [];
    let termsUrl = response.MVConfiguration?.URLConfig?.TermsAndConditionUrl || '';
    let privacyPolicyUrl = response.MVConfiguration?.URLConfig?.PrivacyPolicyUrl || '';
    let helpUrl = response.MVConfiguration?.URLConfig?.HelpUrl || '';
    let accessibilityUrl = response.MVConfiguration?.URLConfig?.AccessibilityUrl || '';
    let desktopBgImage = mvStyle?.DesktopBgImage || '';
    let secondaryButtonStyle = mvStyle?.SecondaryButtonStyle || '';
    let primaryButtonStyle = mvStyle?.PrimaryButtonStyle || '';
    let auxiliary1TextColor = mvStyle?.Auxiliary1TextColor || '';
    let tabletBgImage = mvStyle?.TabletBgImage || '';
    let mobileBgImage = mvStyle?.MobileBgImage || '';
    let selectedSectionColor = mvStyle?.SelectedSectionColor || '';
    let unselectedSectionColor = mvStyle?.UnselectedSectionColor || '';
    let identTypeArray = response.MVConfiguration?.PlayerRegistrationConfig?.IdentType || [];
    let addresstype = response.MVConfiguration?.PlayerRegistrationConfig?.AddressType || '';
    let emailType = response.MVConfiguration?.PlayerRegistrationConfig?.EmailType || '';
    let phoneType = response.MVConfiguration?.PlayerRegistrationConfig?.PhoneType || '';
    let appPlayerManagementSystemAttributes = response.MVConfiguration?.PlayerManagementSystemAttributes || {};

    let accountIdMapConfig = response?.MVConfiguration?.Metadata?.AccountIdMap || {};
    this.loginDetailsService.setAccountIdMapConfig(accountIdMapConfig);

    let defaultPlayerLocation = response.MVConfiguration?.PlayerRegistrationConfig?.DefaultPlayerLocation || {
      countryCode: 'US',
      stateCode: 'NV'
    };
    let supportNewPlayerRegistration = response.MVConfiguration?.PlayerRegistrationConfig?.SupportNewPlayerRegistration || false;
    let playerRegistrationOptionalFields = response.MVConfiguration?.PlayerRegistrationConfig?.PlayerRegistrationOptionalFields;
    let playerMinimumAgeLimit = response.MVConfiguration?.PlayerRegistrationConfig?.PlayerMinimumAgeLimit || 21;
    let supportWinLossStatement = response.MVConfiguration?.FeatureSet?.SupportWinLossStatement || false;
    let supportAccountDeletion = response.MVConfiguration?.FeatureSet?.SupportAccountDeletion || false;
    let supportPromotionalMoney = response.MVConfiguration?.FeatureSet?.SupportPromotionalMoney || false;
    let disableAccountEmailUnlinking = response.MVConfiguration?.FeatureSet?.DisableAccountEmailUnlinking || false;
    let supportPinChange = response.MVConfiguration?.FeatureSet?.SupportPinChange || false;
    let supportChangePassword = response.MVConfiguration?.FeatureSet?.SupportChangePassword || false;
    let supportTOTPMfa = response.MVConfiguration?.FeatureSet?.SupportTOTPMfa || false;
    let showMfaSetupOnRegistration = response.MVConfiguration?.FeatureSet?.ShowMfaSetupOnRegistration || false;
    const supportOTPValidationForPlayerLinking = response.MVConfiguration?.FeatureSet?.SupportOTPValidationForPlayerLinking ?? true;
    let supportedCurrencyFormat = response.MVConfiguration?.CultureInfo?.CurrencyFormat || {};
    let supportedDateTimeFormat = response.MVConfiguration?.CultureInfo?.DateTimeFormat || {};
    let supportedOfferDateTimeFormat = response.MVConfiguration?.OfferConfigration?.DateTimeFormat || {};
    let tierConfiguration = response.MVConfiguration?.TierConfigration || {};
    let drawingConfigs = response.MVConfiguration?.DrawingsConfig || [];
    let supportDrawingBalances = response.MVConfiguration?.FeatureSet?.SupportDrawings || false;
    let supportAllowAccountInfoEdit = response.MVConfiguration?.FeatureSet?.AllowAccountInfoEdit || false;
    let fetchDrawingBalancesUsingDirectApiCall = response.MVConfiguration?.FeatureSet?.FetchDrawingBalancesUsingDirectApiCall || false;
    let isIdentVerificationRequired = response.MVConfiguration?.Metadata?.IsIdentVerificationRequired || false;

    this.loginDetailsService.setDefaultPlayerLocation(defaultPlayerLocation);

    // save BaseURL
    this.loginDetailsService.setEndpointConfigurations(systemConfigurations.BaseUrl);

    // set AllCountriesAndStatesDataUrl
    this.loginDetailsService.setAllCountriesAndStatesDataUrl(allCountriesAndStatesDataUrl);

    // save the player attributes
    this.loginDetailsService.setPlayerAttributes(playerManagementSystemAttributes.PropertyId,
      playerManagementSystemAttributes.ClientId,
      playerManagementSystemAttributes.TransEmployee,
      playerManagementSystemAttributes.TransEmployeeRole,
      playerManagementSystemAttributes.TransLocation);

    // set the TenantCode
    this.loginDetailsService.setTenantCode(this.appConfigs.tenantCode);

    // set AccountIdMap for player balances
    this.loginDetailsService.setPlayerBalanceAccountMap([accountIdMap.Points, accountIdMap.Promo]);

    // set player account configurations
    this.loginDetailsService.setPlayerAccountConfigurations(myAccountConfiguration);

    // set the CMSOfferTypes
    this.loginDetailsService.setCMSOfferTypes(cmsOfferTypes);

    // set the OfferConfigration
    this.loginDetailsService.setOfferConfiguration(OfferConfigration);


    // set the mvStyle
    this.loginDetailsService.setMVStyle(mvStyle);

    // SET HEADER IMAGE
    this.loginDetailsService.setHeaderImage(mvStyle.HeaderLogoImage);
    this.loginDetailsService.setFavIcon(mvStyle.FavLogoImage);
    this.loginDetailsService.setTitle(mvStyle.FavNameText);

    // set the appThemingStyle
    this.loginDetailsService.setAppThemingStyle(appThemingStyle);
    this.themeDataService.applyApplicationThemingStyles();

    // set the tierLevelBenefits
    this.loginDetailsService.setTierLevelBenefits(tierLevelBenefits);

    // set the termsUrl
    this.loginDetailsService.setTermsUrl(termsUrl);

    // set the privacyPolicyUrl
    this.loginDetailsService.setPrivacyPolicyUrl(privacyPolicyUrl);

    // set the helpUrl
    this.loginDetailsService.setHelpUrl(helpUrl);

    // set the accessibilityUrl
    this.loginDetailsService.setAccessibilityUrl(accessibilityUrl);

    // set the desktopBgImage
    this.loginDetailsService.setDesktopBgImage(desktopBgImage);

    // set the secondaryButtonStyle
    this.loginDetailsService.setSecondaryButtonStyle(secondaryButtonStyle);

    // set the primaryButtonStyle
    this.loginDetailsService.setPrimaryButtonStyle(primaryButtonStyle);

    // set the auxiliary1TextColor
    this.loginDetailsService.setAuxiliary1TextColor(auxiliary1TextColor);

    // set the tabletBgImage
    this.loginDetailsService.setTabletBgImage(tabletBgImage);

    // set the mobileBgImage
    this.loginDetailsService.setMobileBgImage(mobileBgImage);

    // set the selectedSectionColor
    this.loginDetailsService.setSelectedSectionColor(selectedSectionColor);

    // set the unselectedSectionColor
    this.loginDetailsService.setUnselectedSectionColor(unselectedSectionColor);

    // set the identTypeArray
    this.loginDetailsService.setIdentTypeArray(identTypeArray);

    // set the addresstype
    this.loginDetailsService.setAddressType(addresstype);

    // set the emailType
    this.loginDetailsService.setEmailType(emailType);

    // set the appPlayerManagementSystemAttributes
    this.loginDetailsService.setAppPlayerManagementSystemAttributes(appPlayerManagementSystemAttributes);

    // set the phoneType
    this.loginDetailsService.setPhoneType(phoneType);

    // set supportNewPlayerRegistration
    this.loginDetailsService.setSupportNewPlayerRegistration(supportNewPlayerRegistration);

    // set playerRegistrationOptionalFields
    this.loginDetailsService.setPlayerRegistrationOptionalFields(playerRegistrationOptionalFields);

    // set playerMinimumAgeLimit
    this.loginDetailsService.setPlayerMinimumAgeLimit(playerMinimumAgeLimit);

    // set supportWinLossStatement
    this.loginDetailsService.setSupportWinLossStatement(supportWinLossStatement);

    // set supportAccountDeletion
    this.loginDetailsService.setSupportAccountDeletion(supportAccountDeletion);

    // set supportPromotionalMoney
    this.loginDetailsService.setSupportPromotionalMoney(supportPromotionalMoney);

    // set disableAccountEmailUnlinking
    this.loginDetailsService.setDisableAccountEmailUnlinking(disableAccountEmailUnlinking);

    // set supportChangePassword      
    this.loginDetailsService.setSupportChangePassword(supportChangePassword);

    // set supportTOTPMfa
    this.loginDetailsService.setSupportTOTPMfa(supportTOTPMfa);

    // set showMfaSetupOnRegistration
    this.loginDetailsService.setShowMfaSetupOnRegistration(showMfaSetupOnRegistration);

    // set supportOTPValidationForPlayerLinking
    this.loginDetailsService.setSupportOTPValidationForPlayerLinking(supportOTPValidationForPlayerLinking);

    // set supportPinChange
    this.loginDetailsService.setSupportPinChange(supportPinChange);

    // set supportedCurrencyFormat
    this.loginDetailsService.setSupportedCurrencyFormat(supportedCurrencyFormat);

    // set supportedDateTimeFormat
    this.loginDetailsService.setSupportedDateTimeFormat(supportedDateTimeFormat);

    // set supportedOfferDateTimeFormat
    this.loginDetailsService.setSupportedOfferDateTimeFormat(supportedOfferDateTimeFormat);

    // set the TierConfigration
    this.loginDetailsService.setTierConfigration(tierConfiguration);

    // set the DrawingConfigs
    this.loginDetailsService.setDrawingConfigs(drawingConfigs);

    // set supportDrawingEntries
    this.loginDetailsService.setSupportDrawingBalances(supportDrawingBalances);

    // set supportAllowAccountInfoEdit
    this.loginDetailsService.setSupportAllowAccountInfoEdit(supportAllowAccountInfoEdit);

    // set fetchDrawingBalancesUsingDirectApiCall
    this.loginDetailsService.setFetchDrawingBalancesUsingDirectApiCall(fetchDrawingBalancesUsingDirectApiCall);

    // set isIdentVerificationRequired
    this.loginDetailsService.setIsIdentVerificationRequired(isIdentVerificationRequired);

    // genarate and set the Menu Tabs (MUST be after all config values are set)
    await this.generateMenuTabs(mvTabs);
  }

  async generateMenuTabs(mvTabsList: any[]) {
    const excludeMenus = this.appConfigs.excludeMenus;
    let menuItems: any[] = [];
    let moreMenuItems: any[] = [];
    let mobileMenus: any[] = [];

    let accountMenuData = JSON.parse(JSON.stringify(menuData));
    await this.checkSupportedMenus(accountMenuData[0].children);
    this.applyTranslation(accountMenuData);

    for (const [index, menu] of mvTabsList.entries()) {
      if (!(excludeMenus.includes(menu.ContentType))) {
        menu.ContentType = menu?.ContentType ? menu?.ContentType : CONTENT_DATA_TYPES.NONE;
        menuItems.push({
          name: menu.Title,
          id: index,
          iconClassName: menu.Icon,
          tooltip: menu.Title,
          routerUrl: this.getRouterURL(menu),
          categoryKey: menu?.Categories ? menu?.Categories[0]?.Key : '',
          contentType: menu?.ContentType,
          defaultContentUrl: menu?.DefaultContentUrl || ''
        });
      } else {
        if (menu.ContentType === 'Account info' && accountMenuData.length > 0) {
          accountMenuData[0].iconClassName = menu?.Icon ? menu?.Icon : '';
        }
      }
    }
    moreMenuItems = menuItems?.filter((menu, index) => menu && index > 2);
    mobileMenus = menuItems?.filter((menu, index) => menu && index <= 2);
    const allMenuItems = window && window?.innerWidth <= 1023 ? mobileMenus : menuItems;
    menuItems = [...allMenuItems, ...accountMenuData];
    this.loginDetailsService.setMenuItems(menuItems);
    this.loginDetailsService.setMoreMenuItems(moreMenuItems);
    this.loginDetailsService.setInitialContentCategoryName(menuItems[0]['name']);
    if (menuItems[0]['categoryKey']) {
      this.loginDetailsService.setInitialContentCategoryKey(menuItems[0]['categoryKey']);
    }
  }

  getRouterURL(menuItem: any) {
    let routerURL = '';
    const name = menuItem?.Title;

    if (menuItem.ContentType === CONTENT_DATA_TYPES.NONE) {
      routerURL = `/${CONTENT_ROUTES_PATHS.DYNAMIC_CONTENT}/${name}`;
    } else if (menuItem.ContentType === CONTENT_DATA_TYPES.OFFERS) {
      routerURL = `/${menuItem?.ContentType}/${name}/${name}`;
    } else {
      routerURL = `/${menuItem.ContentType}/${name}`;
    }
    return routerURL;
  }

  applyTranslation(menus: any[]) {
    menus.forEach((menu) => {
      const translateNameText = `MENU.${menu.name}`;
      const translateTooltip = `MENU.${menu.tooltip}`;
      menu.name = this.toast.gettransloco(translateNameText);
      menu.tooltip = this.toast.gettransloco(translateTooltip);
      if (menu.children) {
        this.applyTranslation(menu.children);
      }
    })
  }

  async getAWSCredentialsData() {
    await this.cryptoService.generatePassPhase();
    let tenantDesc = this.appConfigs.tenantDesc || '';

    if (!tenantDesc) {
      return null;
    }

    let identityPoolData: any = JSON.parse(await this.cryptoService.decrypt(this.cryptoService.hexToArrayBuffer(tenantDesc)));
    if (Object.keys(identityPoolData).length === 0) {
      console.log('Failed to get identity Pool ID');
      return null;
    }

    let identityPoolId = identityPoolData.identityPoolId;
    let apiRegion = identityPoolData.region || '';

    // Get Identity ID object
    let identityId: any = await this.getIdentityId(apiRegion, identityPoolId);
    if (Object.keys(identityId).length === 0) {
      console.log('Failed to get identity ID');
      return null;
    }

    // Get AWS Credentials for Identity
    let awsCredentialData = await this.getAWSCredentials(apiRegion, identityId.IdentityId);
    if (Object.keys(awsCredentialData).length === 0) {
      console.log('Failed to get AWS Credentials');
      return null;
    }

    let awsCredentials: AwsCredentialsData = {
      AccessKey: awsCredentialData.Credentials.AccessKeyId || '',
      SecretKey: awsCredentialData.Credentials.SecretKey || '',
      region: apiRegion,
      sessionToken: awsCredentialData.Credentials.SessionToken || '',
      expiry: awsCredentialData.Credentials.Expiration,
      contentRegion: identityPoolData.contentRegion || ''
    };

    // set/save the  awsCredentials
    this.loginDetailsService.setAwsSignatureAuthorizationConfig(awsCredentials);
  }

  resetConfigLoaded(): void {
    this.configLoaded = false;
    this.configLoadingPromise = null;
  }

  async getContentsAndConfigurationsData(): Promise<void> {
    if (this.configLoaded) {
      return;
    }

    if (this.configLoadingPromise) {
      return this.configLoadingPromise;
    }

    this.configLoadingPromise = this._performLoadContentsAndConfigurations()
      .then(() => { this.configLoaded = true; })
      .finally(() => { this.configLoadingPromise = null; });

    return this.configLoadingPromise;
  }

  private async _performLoadContentsAndConfigurations(): Promise<void> {
    try {
      this.loaderService.setLoaderStateActive(true, 'contents_configurations_service_url');
      const awsConfigs = await this.loginDetailsService.getAwsSignatureAuthorizationConfig();

      if (!awsConfigs) {
        throw new Error('AWS credentials unavailable');
      }

      const response = await this.getSystemsConfigurationsAsync();
      await this.saveConfigurations(response);

      this.configurationService.getConfigurationsApiData().subscribe((results) => {
        const hasTimeoutError =
          results.siteIdsData?.timedOut ||
          results.offerTypesData?.timedOut ||
          results.clubRulesData?.timedOut;

        if (hasTimeoutError) {
          // this.toast.toastErrorMsg('INTERNAL_SERVER_ERROR.message');
          localStorage.setItem('hasAPIFacedError', 'true');
        }

        if (!results.siteIdsData.error) {
          this.loginDetailsService.setSiteIds(results.siteIdsData);
        }

        if (!results.offerTypesData.error) {
          this.loginDetailsService.setOfferTypes(results.offerTypesData);
        }

        if (!results.clubRulesData.error) {
          this.loginDetailsService.setClubRules(results.clubRulesData);
        }

        this.loaderService.setLoaderStateActive(false, 'contents_configurations_service_url');
      });
    } catch (error) {
      this.loaderService.setLoaderStateActive(false, 'contents_configurations_service_url');
      throw error;
    }
  }

  isAWSTokenExpired(validity: any): boolean {
    if (validity === null || validity <= 0) {
      return true;
    }
    let currentDateTime = Date.now();
    let expirationDate = new Date(validity * 1000);
    expirationDate.setMinutes(expirationDate.getMinutes() - 5); // Expire 5 mins earlier
    return currentDateTime > expirationDate.getTime();
  }

  async checkSupportedMenus(staticMenus: any[]) {
    // Check and remove WIN_LOSS_STATEMENT if not supported
    const winLossIndex = staticMenus.findIndex(menu => menu.name === 'WIN_LOSS_STATEMENT');
    if (winLossIndex !== -1) {
      const supportWinLossStatement = this.loginDetailsService.supportWinLossStatement || false;
      if (!supportWinLossStatement) {
        staticMenus.splice(winLossIndex, 1);
      }
    }

    // Check and remove ACCOUNT_SECURITY if no child options are available
    const accountSecurityIndex = staticMenus.findIndex(menu => menu.name === 'ACCOUNT_SECURITY');
    if (accountSecurityIndex !== -1) {
      const disableAccountEmailUnlinking = this.loginDetailsService.disableAccountEmailUnlinking || false;
      const supportChangePassword = this.loginDetailsService.supportChangePassword || false;
      const supportTOTPMfa = this.loginDetailsService.supportTOTPMfa || false;
      const supportPinChange = this.loginDetailsService.supportPinChange || false;
      const isIdentVerificationRequired = this.loginDetailsService.isIdentVerificationRequired || false;

      let isPinChangeAvailable = false;
      // Only check identity verification if player data is available
      if (supportPinChange &&
        this.loginDetailsService.playerId &&
        this.loginDetailsService.baseUrl &&
        this.loginDetailsService.propertyId &&
        this.loginDetailsService.clientId) {
        // Use the reusable method from PlayerService
        isPinChangeAvailable = await this.playerService.checkIdentityVerificationStatus(
          isIdentVerificationRequired,
          this.playerInformationService
        );
      }

      // Show Account Security if at least one child option is available
      const hasVisibleOptions = !disableAccountEmailUnlinking || supportChangePassword || supportTOTPMfa || isPinChangeAvailable;

      if (!hasVisibleOptions) {
        staticMenus.splice(accountSecurityIndex, 1);
      }
    }
  }
}